// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d0bc6a8d","455":"b60921db","977":"0ad864fa"}[chunkId] + ".chunk.js";
};